import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography, makeStyles } from '@material-ui/core';
import { getAlignItem, getColumnWidth } from '../../../../constants/gridTable';

const useStyles = makeStyles(({ spacing }) => ({
  main: {
    display: 'grid',
    boxSizing: 'border-box',
    paddingBottom: spacing(4.5),
    paddingLeft: spacing(2),
    paddingRight: spacing(2),
    columnGap: spacing(2),
  },
  headerCell: {
    textAlign: 'left',
    lineHeight: '24px',
    userSelect: 'none',
  },
}));

const CardsTableHeader = ({ customHeaderClass = null, headers }) => {
  const classes = useStyles();

  return (
    <div
      className={classNames(
        classes.main,
        'grid-table-header',
        'cards-table-header',
        customHeaderClass
      )}
      style={getColumnWidth(headers)}
    >
      {headers.map(header => (
        <Typography
          component="div"
          variant="subtitle1"
          key={`header_cell_${header.id}`}
          className={classNames(classes.headerCell, header.headerCellClass)}
          style={getAlignItem(header)}
        >
          {header.title || ''}
        </Typography>
      ))}
    </div>
  );
};

CardsTableHeader.propTypes = {
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      rowKey: PropTypes.string.isRequired,
      sortAs: PropTypes.string,
      align: PropTypes.string,
      minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      headerCellClass: PropTypes.string,
      isHeaderAction: PropTypes.bool,
      isSortingDisabled: PropTypes.bool,
    })
  ).isRequired,
  customHeaderClass: PropTypes.string,
};

export default CardsTableHeader;
